import { useContext, useState } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { CheckIcon, ExclamationCircleIcon, TrashIcon, XMarkIcon } from '@heroicons/react/24/outline'

import ModalContainer from 'components/ModalContainer'
import { Card, Button } from 'components/gsys-ui'

const ConfirmModal = NiceModal.create(({ handleConfirm, title, desc }) => {
  const modal = useModal()
  const [isConfirming, setConfirming] = useState(false)

  const handleClickConfirm = async () => {
    setConfirming(true)
    await handleConfirm()
    modal.remove()
  }

  return (
    <ModalContainer>
      <Card className="!w-[350px]">
        <div className="flex flex-col items-center p-3 w-full">
          <div className="flex justify-center items-center mb-2 w-12 h-12 bg-green-100 rounded-full">
            <CheckIcon className="w-8 h-8 text-green-500" />
          </div>
          <div className="text-lg font-bold">{title}</div>
          <div className="mb-4">{desc}</div>
          <div className="flex space-x-4 w-full">
            <Button variant="white" className="flex-1 justify-center" onClick={() => modal.remove()}>
              <XMarkIcon className="mr-1 w-5 h-5" />
              Cancel
            </Button>
            <Button variant="green" loading={isConfirming} className="flex-1 justify-center" onClick={handleClickConfirm}>
              <CheckIcon className="mr-1 w-5 h-5" />
              Confirm
            </Button>
          </div>
        </div>
      </Card>
    </ModalContainer>
  )
})

export default ConfirmModal